<template>
  <button 
    type="button"
    class="
          px-2 py-1 h-8 text-sm
          lg:px-4 lg:py-2 lg:h-12 lg:text-lg
          rounded-lg border-2 border-transparent
          font-semibold text-skin-b-invt 
          bg-skin-active128
          disabled:opacity-50 disabled:hover:bg-skin-active128 
          hover:bg-skin-active96
          focus:bg-skin-active128 focus:outline-none focus:ring-0 
          active:bg-skin-active128 
          transition duration-300 ease-in-out">
          <slot></slot>
  </button>
</template>